// extracted by mini-css-extract-plugin
export default {"l_Overlay_main":"Overlay_l_Overlay_main__4wWCc","open":"Overlay_open__git29"};